import React from 'react'
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import axios from "axios";
function Contactus() {
    const location = useLocation();
  
    useEffect(() => {
        const name = location.pathname;
        document.body.className = name.substring(1) + "-body";
    }, [location]);

 

      const [formData, setFormData] = useState({
        name: "",
        email: "",
        number: "",
        message: ""
      });
      const [errors, setErrors] = useState({});
      const validate = () => {
        let tempErrors = {};
        if (!formData.name) tempErrors.name = "Name is required";
        if (!formData.email) tempErrors.email = "Email is required";
        if (!formData.number) tempErrors.number = "Phone number is required";
        else if (!/^(\+?\d*)$/.test(formData.number)) tempErrors.number = "Phone number must be numeric";
        else if (formData.number.length < 8 || formData.number.length > 14) tempErrors.number = "Phone number must be between 8 and 14 digits";
        if (!formData.message) tempErrors.message = "Message is required";
        setErrors(tempErrors);
        return Object.keys(tempErrors).length === 0;
    };
    
      const handleChange = (e) => {
        setFormData({
          ...formData,
          [e.target.name]: e.target.value
        });
      };
      const handleKeyPress = (e) => {
        const validChars = /^[0-9+]+$/;
        if (!validChars.test(e.key)) {
            e.preventDefault();
        }
    };

     const handleSubmit = async (e) => {
     e.preventDefault();
    if (!validate()) return;
    
    try {
      // Send form data to the backend API
      const response = await axios.post("https://appapi.comtechgold.com/api/comtechdmmc/create", formData);
            
      console.log('response',response )
      if (response.status == 200) {
        window.alert('Email sent successfully!');
      } else {
        window.alert('"Failed to send email');
      }
    } catch (error) {
      console.error("Error sending email", error);
      alert("Failed to send email.");
    }

    // Clear form
    setFormData({ name: "", email: "", number: "", message: "" });
  };
  return (
        <div className="contactus container">
            <div className="left-contactus">
                <h1 className="contactus-h1">Get in Touch</h1>
                <div className="contact-left">
                    <form onSubmit={handleSubmit}>
                        <div className="d-flex contactus-form">
                            <i className="fas fa-user"></i>
                            <input
                                type="text"
                                placeholder="Name.."
                                name="name"
                                id="name"
                                value={formData.name}
                                onChange={handleChange}
                                autoComplete="off"
                            />
                        </div>
                        {errors.name && <span className="error">{errors.name}</span>}
                        
                        <div className="d-flex contactus-form">
                            <i className="fas fa-envelope"></i>
                            <input
                                type="email"
                                placeholder="Email.."
                                name="email"
                                id="email"
                                value={formData.email}
                                onChange={handleChange}
                                autoComplete="off"
                            />
                        </div>
                        {errors.email && <span className="error">{errors.email}</span>}
                        
                        <div className="d-flex contactus-form">
                            <i className="fas fa-phone-volume"></i>
                            <input
                                type="tel"
                                placeholder="Phone Number.."
                                name="number"
                                id="number"
                                value={formData.number}
                                onChange={handleChange}
                                onKeyPress={handleKeyPress}
                                autoComplete="off"
                            />
                        </div>
                        {errors.number && <span className="error">{errors.number}</span>}
                        
                        <div className="d-flex contactus-form">
                            <i className="fas fa-message message-icon"></i>
                            <textarea
                                type="text"
                                placeholder="Your Message.."
                                name="message"
                                id="message"
                                value={formData.message}
                                onChange={handleChange}
                                autoComplete="off"
                                rows="4"
                                cols="50"
                            />
                        </div>
                        {errors.message && <span className="error">{errors.message}</span>}
                        
                        <div className="text-center">
                            <input className="contact-button" type="submit" value="Send Message" />
                        </div>
                    </form>
                </div>
            </div>
            <div className="right-contactus">
                <div className="right-div-contactus mt-5">
                    <img src="../assets/images/contact-us-image.png" className="contactus-img" alt="" />
                </div>
                <div className="contactus-text d-flex ms-2 mt-5">
                    <i className="fas fa-house"></i>
                    <p className="mb-0 align-self-center">
                        1509, Platinum Tower, Cluster-I, Jumeirah Lakes Towers, Dubai, United Arab Emirates
                    </p>
                </div>
                <div className="contactus-text d-flex ms-2 mt-2">
                    <i className="fas fa-envelope"></i>
                    <p className="mb-0 align-self-center"> <a href="mailto: info@comtechdmcc.com">Info@comtechdmcc.com </a></p>
                </div>
                <div className="contactus-text d-flex ms-2 mt-2">
                    <i className="fas fa-phone-volume"></i>
                    <p className="mb-0 align-self-center">+971 800 2668324</p>
                </div>
            </div>
        </div>
    );
}

export default Contactus;